import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import commonENG from "./locales/eng/common.json";
import errorInvoiceENG from "./locales/eng/errorInvoice.json";
// import workflowsManagementENG from "./locales/eng/workflowsManagement.json";
import VATManagerENG from "./locales/eng/GeneralInfo/VATManager.json";
import businessUnitENG from "./locales/eng/GeneralInfo/businessUnit.json";
import currencyManagerENG from "./locales/eng/GeneralInfo/currencyManager.json";
import customerENG from "./locales/eng/GeneralInfo/customer.json";
import userENG from "./locales/eng/GeneralInfo/user.json";

import invoiceSymbolENG from "./locales/eng/GeneralInfo/invoiceSymbol.json";
import paymentMethodManagerENG from "./locales/eng/GeneralInfo/paymentMethodManager.json";
import productENG from "./locales/eng/GeneralInfo/product.json";
import invoicePosENG from "./locales/eng/invoicePos.json";
import invoiceStatementENG from "./locales/eng/invoiceStatement.json";
import issueInvoiceENG from "./locales/eng/issueInvoice.json";
// ENG
import invoiceTemplateENG from "./locales/eng/invoiceTemplates.json";
import noticeFromTCTENG from "./locales/eng/noticeFromTCT.json";
import registryDelegateENG from "./locales/eng/registryDelegate.json";
import registryInvoiceENG from "./locales/eng/registryInvoice.json";
import requestInvoiceCodeENG from "./locales/eng/requestInvoiceCode.json";
import summaryInvoiceDataENG from "./locales/eng/summaryInvoiceData.json";
import translationENG from "./locales/eng/translation.json";
import warehouseAgencyENG from "./locales/eng/warehouseAgency.json";

import signMethodENG from "./locales/eng/GeneralInfo/signMethod.json";
import businessConfigurationENG from "./locales/eng/businessConfiguration.json";
import businessEmailTemplateENG from "./locales/eng/businessEmailTemplates.json";
import businessInfoENG from "./locales/eng/businessInfo.json";
// VN
// import caseManagementVN from "./locales/vn/caseManagement.json";
import commonVN from "./locales/vn/common.json";
import {
  default as deliveryBillENG,
  default as deliveryBillVN,
} from "./locales/vn/deliveryBill.json";
import errorInvoiceVN from "./locales/vn/errorInvoice.json";
// import workflowsManagementVN from "./locales/vn/workflowsManagement.json";
import VATManagerVN from "./locales/vn/GeneralInfo/VATManager.json";
import businessUnitVN from "./locales/vn/GeneralInfo/businessUnit.json";
import currencyManagerVN from "./locales/vn/GeneralInfo/currencyManager.json";
import customerVN from "./locales/vn/GeneralInfo/customer.json";
import userVN from "./locales/vn/GeneralInfo/user.json";

import invoiceSymbolVN from "./locales/vn/GeneralInfo/invoiceSymbol.json";
import paymentMethodManagerVN from "./locales/vn/GeneralInfo/paymentMethodManager.json";
import productVN from "./locales/vn/GeneralInfo/product.json";
import signMethodVN from "./locales/vn/GeneralInfo/signMethod.json";
import businessConfigurationVN from "./locales/vn/businessConfiguration.json";
import businessEmailTemplateVN from "./locales/vn/businessEmailTemplates.json";
import businessInfoVN from "./locales/vn/businessInfo.json";
import invoicePosVN from "./locales/vn/invoicePos.json";
import invoiceStatementVN from "./locales/vn/invoiceStatement.json";
import invoiceTemplateVN from "./locales/vn/invoiceTemplates.json";
import issueInvoiceVN from "./locales/vn/issueInvoice.json";
import noticeFromTCTVN from "./locales/vn/noticeFromTCT.json";
import registryDelegateVN from "./locales/vn/registryDelegate.json";
import registryInvoiceVN from "./locales/vn/registryInvoice.json";
import requestInvoiceCodeVN from "./locales/vn/requestInvoiceCode.json";
import summaryInvoiceDataVN from "./locales/vn/summaryInvoiceData.json";
import translationVN from "./locales/vn/translation.json";
import warehouseAgencyVN from "./locales/vn/warehouseAgency.json";

import taxDeductENG from "./locales/eng/taxDeduct.json";
import taxDeductRegisterENG from "./locales/eng/taxDeductRegister.json";
import taxDeductVN from "./locales/vn/taxDeduct.json";
import taxDeductRegisterVN from "./locales/vn/taxDeductRegister.json";

// the translations
const resources = {
  en: {
    translation: translationENG,
    common: commonENG,

    // caseManagement: caseManagementENG,
    // workflowsManagement: workflowsManagementENG,
    businessUnit: businessUnitENG,
    currencyManager: currencyManagerENG,
    paymentMethodManager: paymentMethodManagerENG,
    VATManager: VATManagerENG,
    invoiceSymbol: invoiceSymbolENG,
    errorInvoice: errorInvoiceENG,
    registryInvoice: registryInvoiceENG,
    registryDelegate: registryDelegateENG,
    requestInvoiceCode: requestInvoiceCodeENG,
    noticeFromTCT: noticeFromTCTENG,
    issueInvoice: issueInvoiceENG,
    invoicePos: invoicePosENG,
    invoiceStatement: invoiceStatementENG,
    summaryInvoiceData: summaryInvoiceDataENG,
    deliveryBill: deliveryBillENG,
    product: productENG,
    customer: customerENG,
    user: userENG,
    warehouseAgency: warehouseAgencyENG,
    invoiceTemplate: invoiceTemplateENG,
    businessInfo: businessInfoENG,
    businessConfiguration: businessConfigurationENG,
    businessEmailTemplate: businessEmailTemplateENG,
    signMethod: signMethodENG,
    taxDeductRegister: taxDeductRegisterENG,
    taxDeduct: taxDeductENG,
  },
  vn: {
    translation: translationVN,
    common: commonVN,
    // jobTitle: jobTitleVN,
    // templateManagement: templateManagementVN,
    // caseManagement: caseManagementVN,
    // eDocumentManagement: eDocumentManagementVN,
    // employeeManagement: employeeManagementVN,
    // workflowsManagement: workflowsManagementVN,
    businessUnit: businessUnitVN,
    currencyManager: currencyManagerVN,
    paymentMethodManager: paymentMethodManagerVN,
    VATManager: VATManagerVN,
    invoiceSymbol: invoiceSymbolVN,
    errorInvoice: errorInvoiceVN,
    registryInvoice: registryInvoiceVN,
    registryDelegate: registryDelegateVN,
    requestInvoiceCode: requestInvoiceCodeVN,
    noticeFromTCT: noticeFromTCTVN,
    issueInvoice: issueInvoiceVN,
    invoicePos: invoicePosVN,
    invoiceStatement: invoiceStatementVN,
    summaryInvoiceData: summaryInvoiceDataVN,
    deliveryBill: deliveryBillVN,
    product: productVN,
    customer: customerVN,
    user: userVN,
    warehouseAgency: warehouseAgencyVN,
    invoiceTemplate: invoiceTemplateVN,
    businessInfo: businessInfoVN,
    businessConfiguration: businessConfigurationVN,
    businessEmailTemplate: businessEmailTemplateVN,
    signMethod: signMethodVN,
    taxDeductRegister: taxDeductRegisterVN,
    taxDeduct: taxDeductVN,
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "vn");
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "vn",
    fallbackLng: "en", // use en if detected lng is not available

    // keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
